export var ESpecialViews = /*#__PURE__*/function (ESpecialViews) {
  ESpecialViews["MessageSent"] = "messageSent";
  return ESpecialViews;
}({});